<template>
    <component :is="componentEntity" v-if="isComponentNameExist" :article="article" :category="category" />
    <div v-else>
        <p style="color:red">Error: 模板不存在,后台配置的vueTemplateName: {{ article!.vueTemplateName! }} 名称在前端不存在！</p>
    </div>
</template>

<script setup lang="ts" name="ArticleIndex">
    import { ref, shallowRef } from 'vue'
    import type { Article, ArticleListPo, CmsInfo, Response } from '~/types'
    import { useHttpBy$Fetch, useHttp } from '~/utils/httpUtil'
    const route = useRoute()

    const componentEntity = shallowRef()
    const isComponentNameExist = ref(true)

    // 根据文章的完整url 获取文章的分类、再获取整个网站的详情
    const cmsInfo = await cmsUtils.getCmsInfo() as CmsInfo;
    const category = cmsUtils.getCategoryDetailByArticleFullUrl(route.path, cmsInfo)

    const { data: article } = await useHttpBy$Fetch("/nuxt/article/detail", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: {
            "titleUrl": route.path.split('/').at(-1)!.replace('.html', ''),
            "websiteId": cmsInfo.website.id,
            "categoryId": category!.id
        } 
    }) as Response<Article>;


    if (!article) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Article Page not found'
        })
    }


    const canonicalUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain + route.path.replace('.html','')
    const siteName = cmsInfo.website.title || cmsInfo.website.domain
    const ogImage = article.imageUrl?.split(',')[0] || ''
    useHead({
        title: article.title,
        meta: [
            { name: 'title', content: article.title },
            { name: 'keywords', content: article.keywords },
            { name: 'description', content: article.description },
            // Open Graph
            { property: 'og:title', content: article.title },
            { property: 'og:description', content: article.description },
            { property: 'og:url', content: canonicalUrl },
            { property: 'og:type', content: 'article' },
            { property: 'og:site_name', content: siteName },
            ...(ogImage ? [{ property: 'og:image', content: ogImage }] : []),
            ...(ogImage ? [{ property: 'og:image:alt', content: article.title }] : []),
            // Twitter Card
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: article.title },
            { name: 'twitter:description', content: article.description },
            ...(ogImage ? [{ name: 'twitter:image', content: ogImage }] : []),
        ],
        link: [
            { rel: 'canonical', href: canonicalUrl }
        ]
    })

    isComponentNameExist.value = cmsUtils.checkComponentNameExist(article.vueTemplateName ? article.vueTemplateName : 'ArticleDefault')
    if (isComponentNameExist.value) {
        if (article.vueTemplateName) {
            componentEntity.value = resolveComponent(article.vueTemplateName)
        } else {
            componentEntity.value = resolveComponent('ArticleDefault')
        }
    }
</script>
<style scoped lang="scss"></style>
